module.exports = __webpack_public_path__ + "static/img/payment_top.72f9e51.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/payment_top.png
// module id = zXNh
// module chunks = 0